<!-- <app-header-auth></app-header-auth> -->

<section class="ml-register">
  <div class="ml-register__background" aria-hidden="true">
    <div class="ml-register__glow ml-register__glow--left"></div>
    <div class="ml-register__glow ml-register__glow--right"></div>
    <div class="ml-register__grid"></div>
  </div>

  <div class="ml-register__container">

    <!-- LEFT SIDE -->

    <aside class="ml-register__intro">
      <div class="ml-register__badge">
        <span>
          <i class="fi fi-rr-sparkles"></i>
        </span>

        <strong>MENULOAD FOR RESTAURANTS</strong>
      </div>

      <h1>
        შექმენი შენი
        <span>რესტორნის ონლაინ სივრცე</span>
      </h1>

      <p>
        ერთი რეგისტრაციით შექმენი ანგარიში, დაამატე
        რესტორნის ინფორმაცია და აირჩიე უნიკალური
        Menuload მისამართი.
      </p>

      <div class="ml-register__advantages">
        <div class="ml-register-advantage">
          <span>
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>ციფრული QR მენიუ</strong>
            <small>
              შექმენი მენიუ, რომელიც მომხმარებელს
              პირდაპირ ტელეფონში გაეხსნება.
            </small>
          </div>
        </div>

        <div class="ml-register-advantage">
          <span>
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>ონლაინ შეკვეთები</strong>
            <small>
              მიიღე და მართე შეკვეთები რეალურ დროში.
            </small>
          </div>
        </div>

        <div class="ml-register-advantage">
          <span>
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>უნიკალური საიტის მისამართი</strong>
            <small>
              მიიღე საკუთარი მისამართი:
              restaurant.menuload.com
            </small>
          </div>
        </div>
      </div>

      <div class="ml-register__security">
        <span>
          <i class="fi fi-rr-shield-check"></i>
        </span>

        <div>
          <strong>უსაფრთხო რეგისტრაცია</strong>
          <small>
            შენი მონაცემები დაცული კავშირით იგზავნება.
          </small>
        </div>
      </div>
    </aside>

    <!-- REGISTRATION FORM -->

    <div class="ml-register__form-column">
      <div class="ml-register-card">

  <!-- FORM TITLE -->

  <div class="ml-register-card__heading">
    <span class="ml-register-card__icon">
      <i class="fi fi-rr-user-add"></i>
    </span>

    <div>
      <span class="ml-register-card__eyebrow">
        START WITH MENULOAD
      </span>

      <h2>რეგისტრაცია</h2>

      <p>
        შექმენი ანგარიში და შენი რესტორნის საიტი.
      </p>
    </div>
  </div>

  <!-- PROGRESS -->

  <div class="ml-register-progress">
    <div class="ml-register-progress__top">
      <div>
        <span>
          ნაბიჯი {{ currentStep }} / 3
        </span>

        <strong>
          <ng-container *ngIf="currentStep === 1">
            ანგარიშის ინფორმაცია
          </ng-container>

          <ng-container *ngIf="currentStep === 2">
            რესტორნის ინფორმაცია
          </ng-container>

          <ng-container *ngIf="currentStep === 3">
            საიტის მისამართი
          </ng-container>
        </strong>
      </div>

      <small>{{ stepProgress | number:'1.0-0' }}%</small>
    </div>

    <div class="ml-register-progress__track">
      <span [style.width.%]="stepProgress"></span>
    </div>

    <div class="ml-register-progress__steps">
      <div
        class="ml-register-progress__step"
        [class.is-active]="currentStep >= 1"
        [class.is-current]="currentStep === 1"
      >
        <span>
          <i
            *ngIf="currentStep > 1"
            class="fi fi-rr-check"
          ></i>

          <ng-container *ngIf="currentStep <= 1">
            1
          </ng-container>
        </span>

        <small>ანგარიში</small>
      </div>

      <div
        class="ml-register-progress__step"
        [class.is-active]="currentStep >= 2"
        [class.is-current]="currentStep === 2"
      >
        <span>
          <i
            *ngIf="currentStep > 2"
            class="fi fi-rr-check"
          ></i>

          <ng-container *ngIf="currentStep <= 2">
            2
          </ng-container>
        </span>

        <small>რესტორანი</small>
      </div>

      <div
        class="ml-register-progress__step"
        [class.is-active]="currentStep >= 3"
        [class.is-current]="currentStep === 3"
      >
        <span>3</span>

        <small>დომენი</small>
      </div>
    </div>
  </div>

  <form
    class="ml-register-form"
    [formGroup]="validateForm"
    (ngSubmit)="submitForm()"
    novalidate
  >

    <!-- =====================================================
         STEP 1 — ACCOUNT
    ====================================================== -->

    <div
      class="ml-register-form__section"
      *ngIf="currentStep === 1"
    >
      <div class="ml-register-form__section-title">
        <span>01</span>

        <div>
          <strong>ანგარიშის ინფორმაცია</strong>
          <small>
            შეიყვანე შენი პირადი მონაცემები
          </small>
        </div>
      </div>

      <div class="ml-register-form__grid">

        <!-- NAME -->

        <div class="ml-register-form__group">
          <label for="name">
            {{ 'NAME' | translate }}
          </label>

          <div
            class="ml-register-form__field"
            [class.is-invalid]="
              isControlInvalid('name') ||
              error?.['name']
            "
          >
            <span>
              <i class="fi fi-rr-user"></i>
            </span>

            <input
              id="name"
              type="text"
              formControlName="name"
              placeholder="{{ 'NAME' | translate }}"
              autocomplete="given-name"
            >
          </div>

          <small
            class="ml-register-form__error"
            *ngIf="
              isControlInvalid('name') ||
              error?.['name']
            "
          >
            {{ 'VALIDATION.NAME_REQUIRED' | translate }}
          </small>
        </div>

        <!-- LASTNAME -->

        <div class="ml-register-form__group">
          <label for="lastname">
            {{ 'LASTNAME' | translate }}
          </label>

          <div
            class="ml-register-form__field"
            [class.is-invalid]="
              isControlInvalid('lastname') ||
              error?.['lastname']
            "
          >
            <span>
              <i class="fi fi-rr-user"></i>
            </span>

            <input
              id="lastname"
              type="text"
              formControlName="lastname"
              placeholder="{{ 'LASTNAME' | translate }}"
              autocomplete="family-name"
            >
          </div>

          <small
            class="ml-register-form__error"
            *ngIf="
              isControlInvalid('lastname') ||
              error?.['lastname']
            "
          >
            {{ 'VALIDATION.LASTNAME_REQUIRED' | translate }}
          </small>
        </div>
      </div>

      <!-- EMAIL -->

      <div class="ml-register-form__group">
        <label for="email">
          {{ 'EMAIL' | translate }}
        </label>

        <div
          class="ml-register-form__field"
          [class.is-invalid]="
            isControlInvalid('email') ||
            error?.['email']
          "
        >
          <span>
            <i class="fi fi-rr-envelope"></i>
          </span>

          <input
            id="email"
            type="email"
            formControlName="email"
            placeholder="name@example.com"
            autocomplete="email"
          >
        </div>

        <div
          class="ml-register-form__error"
          *ngIf="isControlInvalid('email')"
        >
          <small
            *ngIf="
              validateForm
                .get('email')
                ?.hasError('required')
            "
          >
            {{ 'VALIDATION.EMAIL_REQUIRED' | translate }}
          </small>

          <small
            *ngIf="
              validateForm
                .get('email')
                ?.hasError('email')
            "
          >
            {{ 'VALIDATION.EMAIL_INVALID' | translate }}
          </small>
        </div>

        <div
          class="ml-register-form__error"
          *ngIf="error?.['email']"
        >
          <small
            *ngIf="
              error?.['email']?.includes(
                'validation.EMAIL_UNIQUE'
              )
            "
          >
            {{ 'VALIDATION.EMAIL_UNIQUE' | translate }}
          </small>

          <small
            *ngIf="
              error?.['email']?.includes(
                'validation.EMAIL_INVALID'
              )
            "
          >
            {{ 'VALIDATION.EMAIL_INVALID' | translate }}
          </small>
        </div>
      </div>

      <!-- PASSWORD -->

      <div class="ml-register-form__group">
        <label for="password">
          {{ 'PASSWORD' | translate }}
        </label>

        <div
          class="ml-register-form__field"
          [class.is-invalid]="
            isControlInvalid('password') ||
            passwordErrors.length > 0
          "
        >
          <span>
            <i class="fi fi-rr-lock"></i>
          </span>

          <input
            id="password"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            placeholder="{{ 'PASSWORD' | translate }}"
            autocomplete="new-password"
          >

          <button
            type="button"
            class="ml-register-form__password-button"
            (click)="togglePasswordVisibility()"
          >
            <i
              [class]="
                showPassword
                  ? 'fi fi-rr-eye-crossed'
                  : 'fi fi-rr-eye'
              "
            ></i>
          </button>
        </div>

        <div
          class="ml-register-password"
          *ngIf="isTyping"
        >
          <div class="ml-register-password__top">
            <span>პაროლის სიძლიერე</span>

            <strong
              [class.is-weak]="passwordStrength <= 40"
              [class.is-medium]="
                passwordStrength > 40 &&
                passwordStrength < 80
              "
              [class.is-strong]="passwordStrength >= 80"
            >
              <ng-container *ngIf="passwordStrength <= 40">
                სუსტი
              </ng-container>

              <ng-container
                *ngIf="
                  passwordStrength > 40 &&
                  passwordStrength < 80
                "
              >
                საშუალო
              </ng-container>

              <ng-container *ngIf="passwordStrength >= 80">
                ძლიერი
              </ng-container>
            </strong>
          </div>

          <div class="ml-register-password__track">
            <span
              [style.width.%]="passwordStrength"
              [class.is-weak]="passwordStrength <= 40"
              [class.is-medium]="
                passwordStrength > 40 &&
                passwordStrength < 80
              "
              [class.is-strong]="passwordStrength >= 80"
            ></span>
          </div>

          <div class="ml-register-password__requirements">
            <span
              [class.is-valid]="hasMinimumPasswordLength"
            >
              <i class="fi fi-rr-check"></i>
              მინიმუმ 8 სიმბოლო
            </span>

            <span
              [class.is-valid]="hasLowercaseLetter"
            >
              <i class="fi fi-rr-check"></i>
              პატარა ლათინური ასო
            </span>

            <span
              [class.is-valid]="hasPasswordNumber"
            >
              <i class="fi fi-rr-check"></i>
              მინიმუმ ერთი ციფრი
            </span>
          </div>
        </div>

        <div
          class="ml-register-form__error"
          *ngIf="passwordErrors.length > 0"
        >
          <small
            *ngFor="let passwordError of passwordErrors"
          >
            {{ passwordError | translate }}
          </small>
        </div>
      </div>

      <div class="ml-register-form__navigation">
        <p class="ml-register-form__login">
          უკვე გაქვს ანგარიში?

          <a routerLink="/signin">
            შესვლა
          </a>
        </p>

        <button
          type="button"
          class="ml-register-form__next"
          (click)="nextStep()"
        >
          გაგრძელება
          <i class="fi fi-rr-arrow-small-right"></i>
        </button>
      </div>
    </div>

    <!-- =====================================================
         STEP 2 — RESTAURANT
    ====================================================== -->

    <div
      class="ml-register-form__section"
      *ngIf="currentStep === 2"
    >
      <div class="ml-register-form__section-title">
        <span>02</span>

        <div>
          <strong>რესტორნის ინფორმაცია</strong>
          <small>
            დაამატე ინფორმაცია შენი ბიზნესის შესახებ
          </small>
        </div>
      </div>

      <!-- RESTAURANT NAME -->

      <div class="ml-register-form__group">
        <label for="restaurant-name">
          რესტორნის სახელი
        </label>

        <div
          class="ml-register-form__field"
          [class.is-invalid]="
            isControlInvalid('restaurant_name')
          "
        >
          <span>
            <i class="fi fi-rr-shop"></i>
          </span>

          <input
            id="restaurant-name"
            type="text"
            formControlName="restaurant_name"
            placeholder="მაგალითად: Gourmet Kitchen"
            autocomplete="organization"
          >
        </div>

        <small
          class="ml-register-form__error"
          *ngIf="isControlInvalid('restaurant_name')"
        >
          შეიყვანე რესტორნის სახელი.
        </small>
      </div>

      <div class="ml-register-form__grid">

        <!-- BUSINESS TYPE -->

        <div class="ml-register-form__group">
          <label for="business-type">
            ბიზნესის ტიპი
          </label>

          <div
            class="
              ml-register-form__field
              ml-register-form__field--select
            "
            [class.is-invalid]="
              isControlInvalid('business_type')
            "
          >
            <span>
              <i class="fi fi-rr-store-alt"></i>
            </span>

            <select
              id="business-type"
              formControlName="business_type"
            >
              <option value="" disabled>
                აირჩიე ტიპი
              </option>

              <option value="restaurant">
                Restaurant
              </option>

              <option value="cafe">
                Café
              </option>

              <option value="bakery">
                Bakery
              </option>

              <option value="fast-food">
                Fast food
              </option>

              <option value="hotel">
                Hotel
              </option>

              <option value="other">
                Other
              </option>
            </select>

            <i
              class="
                fi
                fi-rr-angle-small-down
                ml-register-form__select-arrow
              "
            ></i>
          </div>

          <small
            class="ml-register-form__error"
            *ngIf="isControlInvalid('business_type')"
          >
            აირჩიე ბიზნესის ტიპი.
          </small>
        </div>

        <!-- CITY -->

        <div class="ml-register-form__group">
          <label for="city">
            ქალაქი
          </label>

          <div
            class="ml-register-form__field"
            [class.is-invalid]="isControlInvalid('city')"
          >
            <span>
              <i class="fi fi-rr-marker"></i>
            </span>

            <input
              id="city"
              type="text"
              formControlName="city"
              placeholder="მაგალითად: Batumi"
              autocomplete="address-level2"
            >
          </div>

          <small
            class="ml-register-form__error"
            *ngIf="isControlInvalid('city')"
          >
            შეიყვანე ქალაქი.
          </small>
        </div>
      </div>

      <!-- ADDRESS -->

      <div class="ml-register-form__group">
        <label for="address">
          რესტორნის მისამართი
        </label>

        <div
          class="ml-register-form__field"
          [class.is-invalid]="isControlInvalid('address')"
        >
          <span>
            <i class="fi fi-rr-map-marker"></i>
          </span>

          <input
            id="address"
            type="text"
            formControlName="address"
            placeholder="ქუჩა და ნომერი"
            autocomplete="street-address"
          >
        </div>

        <small
          class="ml-register-form__error"
          *ngIf="isControlInvalid('address')"
        >
          შეიყვანე რესტორნის მისამართი.
        </small>
      </div>

      <div class="ml-register-form__navigation">
        <button
          type="button"
          class="ml-register-form__back"
          (click)="previousStep()"
        >
          <i class="fi fi-rr-arrow-small-left"></i>
          უკან
        </button>

        <button
          type="button"
          class="ml-register-form__next"
          (click)="nextStep()"
        >
          გაგრძელება
          <i class="fi fi-rr-arrow-small-right"></i>
        </button>
      </div>
    </div>

    <!-- =====================================================
         STEP 3 — DOMAIN
    ====================================================== -->

    <div
      class="ml-register-form__section"
      *ngIf="currentStep === 3"
    >
      <div class="ml-register-form__section-title">
        <span>03</span>

        <div>
          <strong>საიტის მისამართი</strong>
          <small>
            აირჩიე უნიკალური Menuload დომენი
          </small>
        </div>
      </div>

      <div class="ml-register-form__group">
        <label for="sub-domain">
          დომენის სახელი
        </label>

        <div
          class="ml-register-domain"
          [class.is-invalid]="
            isControlInvalid('sub_domain') ||
            isDomainTaken
          "
          [class.is-valid]="
            domainChecked &&
            isDomainValid &&
            !isDomainTaken
          "
        >
          <span class="ml-register-domain__icon">
            <i class="fi fi-rr-globe"></i>
          </span>

          <input
            id="sub-domain"
            type="text"
            formControlName="sub_domain"
            placeholder="my-restaurant"
            maxlength="63"
            autocomplete="off"
            spellcheck="false"
            (input)="onSubDomainInput()"
          >

          <span class="ml-register-domain__suffix">
            .menuload.com
          </span>

          <span
            class="ml-register-domain__loader"
            *ngIf="checkingDomain"
          ></span>

          <span
            class="ml-register-domain__status is-success"
            *ngIf="
              !checkingDomain &&
              domainChecked &&
              isDomainValid &&
              !isDomainTaken
            "
          >
            <i class="fi fi-rr-check"></i>
          </span>

          <span
            class="ml-register-domain__status is-error"
            *ngIf="
              !checkingDomain &&
              (
                isDomainTaken ||
                (
                  domainChecked &&
                  !isDomainValid
                )
              )
            "
          >
            <i class="fi fi-rr-cross-small"></i>
          </span>
        </div>

        <small
          class="ml-register-form__help"
          *ngIf="
            !domainChecked &&
            !isControlInvalid('sub_domain')
          "
        >
          გამოიყენე მხოლოდ ლათინური ასოები,
          ციფრები და დეფისი.
        </small>

        <small
          class="ml-register-form__error"
          *ngIf="isControlInvalid('sub_domain')"
        >
          შეიყვანე სწორი დომენის სახელი.
        </small>

        <small
          class="ml-register-form__error"
          *ngIf="isDomainTaken"
        >
          ეს დომენის სახელი უკვე დაკავებულია.
        </small>

        <small
          class="ml-register-form__success"
          *ngIf="
            domainChecked &&
            isDomainValid &&
            !isDomainTaken
          "
        >
          დომენი ხელმისაწვდომია:
          {{ validateForm.get('sub_domain')?.value }}.menuload.com
        </small>
      </div>

      <div class="ml-register-domain-preview">
        <span>
          <i class="fi fi-rr-lock"></i>
        </span>

        <div>
          <small>შენი საიტის მისამართი</small>

          <strong>
            {{
              validateForm.get('sub_domain')?.value ||
              'my-restaurant'
            }}.menuload.com
          </strong>
        </div>
      </div>

      <label class="ml-register-form__terms">
        <input
          type="checkbox"
          formControlName="check"
        >

        <span class="ml-register-form__checkbox">
          <i class="fi fi-rr-check"></i>
        </span>

        <span>
          ვეთანხმები Menuload-ის

          <a
            routerLink="/rules"
            target="_blank"
          >
            წესებსა და პირობებს
          </a>
        </span>
      </label>

      <small
        class="ml-register-form__error"
        *ngIf="isControlInvalid('check')"
      >
        რეგისტრაციისთვის დაეთანხმე წესებსა და პირობებს.
      </small>

      <div
        class="ml-register-form__server-error"
        *ngIf="generalError"
      >
        <span>
          <i class="fi fi-rr-exclamation"></i>
        </span>

        <div>
          <strong>რეგისტრაცია ვერ დასრულდა</strong>
          <small>{{ generalError }}</small>
        </div>
      </div>

      <div class="ml-register-form__navigation">
        <button
          type="button"
          class="ml-register-form__back"
          [disabled]="loading"
          (click)="previousStep()"
        >
          <i class="fi fi-rr-arrow-small-left"></i>
          უკან
        </button>

        <button
          type="submit"
          class="ml-register-form__submit"
          [disabled]="
            loading ||
            checkingDomain ||
            isDomainTaken ||
            !domainChecked
          "
        >
          <span
            class="ml-register-form__loader"
            *ngIf="loading"
          ></span>

          <span>
            {{
              loading
                ? 'იქმნება ანგარიში...'
                : 'ანგარიშისა და საიტის შექმნა'
            }}
          </span>

          <i
            *ngIf="!loading"
            class="fi fi-rr-arrow-small-right"
          ></i>
        </button>
      </div>
    </div>
  </form>
</div>
    </div>
  </div>
</section>